import React from 'react'
import autoBind from 'react-autobind'
import { Link } from 'react-router-dom'
import data from '../data.json'

// import Logo from './Logo'
import NavigationFixed from '../components/NavigationFixed'
import { NavLink } from 'react-router-dom'
import './Nav.css'


import ReactGA from 'react-ga';



ReactGA.initialize('UA-120537053-1',{
  debug: true,
  titleCase: false,
  gaOptions: {
    userId: 123
  }
});

const logPageView = () => {
  ReactGA.set({ page: window.location.pathname });
  ReactGA.pageview(window.location.pathname);
  return null;
};

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transition: false,
      link1: false,
      link2: false,
      link3: false,
      link4: false,
      link5: false,
      link6: false,
    };
    autoBind(this);
  }

  handleClick(){
    this.setState({transition: true});
    setTimeout(() => this.setState({ transition: false}), 500);
  }
  handleOpen(){
    this.child.handleOpen();
  }

  componentDidMount(){
    console.log("dsadas");
    ReactGA.pageview(window.location.pathname);
    var loc = window.location.pathname
    if(loc === "/"){
      this.setState({link1:true, link2:false, link3:false, link4:false, link5:false, link6: false, link7: false,});
    } else if(loc === "/cars"){
      this.setState({link1:false, link2:true, link3:false, link4:false, link5:false, link6: false, link7: false,});
    } else if(loc === "/about"){
      this.setState({link1:false, link2:false, link3:true, link4:false, link5:false, link6: false, link7: false,});
    } else if(loc === "/history"){
      this.setState({link1:false, link2:false, link3:false, link4:true, link5:false, link6: false, link7: false,});
    } else if(loc === "/team"){
      this.setState({link1:false, link2:false, link3:false, link4:false, link5:true, link6: false, link7: false,});
    } else if(loc === "/contact"){
      this.setState({link1:false, link2:false, link3:false, link4:false, link5:false, link6: true, link7: false,});
    } else if(loc === "/press"){
      this.setState({link1:false, link2:false, link3:false, link4:false, link5:false, link6: false, link7: true,});
    } else {
      this.setState({link1:false, link2:false, link3:false, link4:false, link5:false, link6: false});
    }
  }
  render(){
    console.log();
    const link1State = this.state.link1 ? "linkActive" : null;
    const link2State = this.state.link2 ? "linkActive" : null;
    // const link3State = this.state.link3 ? "linkActive" : null;
    const link4State = this.state.link4 ? "linkActive" : null;
    const link5State = this.state.link5 ? "linkActive" : null;
    const link6State = this.state.link6 ? "linkActive" : null;
    const link7State = this.state.link7 ? "linkActive" : null;
    return (
      <div className="wrapper">
        <div className="header">
          <Link to='/' className="headerChild1">
            <img alt="logo" className="headerChild1Img" src="/assets/icons/logoWHITE.png" />
          </Link>
          <div className="headerChild2">
            <NavLink onClick={this.handleClick1} className={link1State+" link"} to="/">HOME</NavLink>
            <NavLink onClick={this.handleClick2} className={link2State+" link"} to="cars">CARS</NavLink>
            {/*<NavLink onClick={this.handleClick3} className={link3State+" link"} to="about">ABOUT</NavLink>*/}
            <NavLink onClick={this.handleClick4} className={link4State+" link"} to="history">HISTORY</NavLink>
            {data.pages[7].Published ?
              <NavLink onClick={this.handleClick5} className={link5State+" link"} to="team">TEAM</NavLink>
              :
              null
            }
            <NavLink onClick={this.handleClick6} className={link6State+" link"} to="contact">CONTACT US</NavLink>
            <NavLink onClick={this.handleClick7} className={link7State+" link"} to="press">PRESS</NavLink>
            <img onClick={this.handleOpen} alt="open" className="openLink" src="/assets/icons/open.png" />
          </div>
        </div>
        <div>
          <NavigationFixed onClick={this.handleClick} ref={instance => { this.child = instance; }} />
        </div>
      </div>
  
);
}}



// WEBPACK FOOTER //
// ./src/components/Nav.js